import { Link } from "react-router-dom";
import { statements } from "@/mocks/statements";

const sorted = [...statements].sort((a, b) => (a.date < b.date ? 1 : -1));
const [featured, ...rest] = sorted;

export default function LatestStatements() {
  return (
    <section aria-labelledby="home-latest" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <h2 id="home-latest" className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              最新官方声明
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
              以下为近期已归档的正式表态，按发布时间倒序排列，点开即可查看公告原文。
            </p>
          </div>
          <Link
            to="/statements"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-600 cursor-pointer"
          >
            查看全部公告
            <span className="flex h-4 w-4 items-center justify-center"><i className="ri-arrow-right-line" /></span>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <article className="overflow-hidden rounded-lg border border-primary-300 bg-background-50">
            <Link to={`/statements/${featured.id}`} className="block cursor-pointer">
              <div className="h-56 w-full overflow-hidden bg-background-200 md:h-64">
                <img
                  src={featured.cover}
                  alt={featured.title}
                  title={`${featured.title} - 黑料官方公告配图`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="flex flex-wrap items-center gap-3 text-xs">
                  <span className="rounded-full bg-primary-500 px-2.5 py-1 font-medium text-background-50">
                    置顶 · {featured.categoryName}
                  </span>
                  <time dateTime={featured.date} className="text-foreground-500">{featured.date}</time>
                </div>
                <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                  {featured.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{featured.summary}</p>
                <p className="mt-4 rounded-md border-l-2 border-accent-500 bg-accent-50 px-3 py-2 text-sm text-accent-900">
                  核实结论：{featured.verdict}
                </p>
              </div>
            </Link>
          </article>

          <div className="flex flex-col divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {rest.slice(0, 3).map((item) => (
              <article key={item.id} className="flex-1">
                <Link to={`/statements/${item.id}`} className="group flex h-full flex-col p-6 cursor-pointer">
                  <div className="flex flex-wrap items-center gap-3 text-xs">
                    <span className="rounded-full bg-secondary-100 px-2.5 py-1 font-medium text-secondary-900">
                      {item.categoryName}
                    </span>
                    <time dateTime={item.date} className="text-foreground-500">{item.date}</time>
                  </div>
                  <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                    {item.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}